// src/components/ParticleBackground.jsx
import React, { useCallback } from 'react';
import Particles from 'react-tsparticles';
import { loadSlim } from 'tsparticles-slim';

function ParticleBackground() {
  const particlesInit = useCallback(async (engine) => {
    await loadSlim(engine); // carga slim, suficiente para fondo
  }, []);

  return (
    <Particles
      id="tsparticles"
      init={particlesInit}
      options={{
        fullScreen: { enable: true, zIndex: -1 },
        background: { color: "#ffffffff" },
        particles: {
          number: { value: 50 },
          size: { value: 3 },
          move: { enable: true, speed: 1 },
          opacity: { value: 0.3 },
          links: { enable: true, color: "#006644", distance: 150 },
        },
        detectRetina: true,
      }}
    />
  );
}

export default ParticleBackground;
